module.exports = __webpack_public_path__ + "static/media/What_you_need_to_know.c9bae5ff.pdf";